// IND-015: cifras del módulo industrial con separador de miles siempre,
// también las de 4 cifras («1.500», no «1500»): es-ES no agrupa 4 cifras por
// defecto. No se usa en años, números de OF, códigos, filas de Excel ni campos
// de entrada.
const GROUPING_ALWAYS = { useGrouping: 'always' } as unknown as Intl.NumberFormatOptions;

export function esNumberFormat(options?: Intl.NumberFormatOptions): Intl.NumberFormat {
  return new Intl.NumberFormat('es-ES', { ...options, ...GROUPING_ALWAYS });
}

export function formatEsNumber(value: number, options?: Intl.NumberFormatOptions): string {
  return esNumberFormat(options).format(value);
}
